<template>
  <el-container>
    <el-header>
      <navmenu/>
    </el-header>
    <el-main>
      <div class="block">
        <el-carousel trigger="click" height="460px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgList" :key="item.name">
            <div class="pic_item">
              <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" />
              <h3>{{item.title}}</h3>
              <p>{{item.detail}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="hadoop">
          <ul>
            <li class="icon_a"><a href="#/cityBrain/socialSolutions">社会态势解决方案</a></li>
            <li class="icon_b"><a href="#/cityBrain/importantSolutions">重点防护解决方案</a></li>
            <li class="icon_c actived"><a href="#/cityBrain/warningSolutions">警情中心解决方案</a></li>
            <li class="icon_d"><a href="#/cityBrain/manySolutions">一标N实解决方案</a></li>
          </ul>
        </div>
      </div>
      <div class="solution">
        <div class="share">
          <div style="height:45px;width:415px;margin:0 auto;"><h2>警情中心解决方案</h2></div>
          <span></span>
        </div>
        <div class="view-tip">
          <p style="line-height:32px;font-size: 16px;color: #666;">全量、全维度汇集警务活动有关的所有案事件信息。实现全量警情汇聚、出口精准分流、警务工作闭环等，为智慧政工考核提供数据支撑，最终实现警务全生命周期管理。</p>
          <div class="detail" style="padding-left: 0px;">
            <div class="cityImg"><img src="../../../public/citybrianImg/city3.png" alt=""> </div>
          </div>
        </div>
        <div class="view-tip change">
          <p class="title">系统价值</p>
          <div class="detail">
            <ul>
              <li><span>汇聚</span><p>依托总体框架，汇聚全量警务情况</p></li>
              <li><span>处置</span><p>打通数据壁垒，高效处置减负基层</p></li>
              <li><span>治理</span><p>融合接报补录，做好数据源头治理</p></li>
              <li><span>反哺</span><p>串联前后环节，沉淀基层反哺系统</p></li>
            </ul>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer>
      <footerMenu/>
    </el-footer>
  </el-container>
</template>

<script>
import navmenu from '../../components/navmenu.vue';
import footerMenu from '../../components/footer.vue';

export default {
  components: { navmenu,footerMenu },

  data(){
    return{
      imgList:[
        {
          name: "banner1",
          title:'城市大脑',
          detail:'City brain',
          src: require("../../../public/citybrianImg/citybrian.png"),
        },
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.share{
  padding:80px 0 60px 0;
  span{
    height: 3px;
    width: 44px;
    display: inline-block;
    background-color: #C5C5C5;
  }
}

.block{
  position: relative;
  .pic_item {
    position: relative;
    height: 100%;
    h3{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 132px;        
      font-size: 60px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:moveh3 3s infinite;
      // animation-iteration-count:1;
      @keyframes moveh3{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
      @-webkit-keyframes moveh3 /*Safari and Chrome*/{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
    }      
    p{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 242px;        
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:movep 3s infinite;
      @keyframes movep{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
      @-webkit-keyframes movep /*Safari and Chrome*/{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
    }
    }      
  }
  .pic_item:hover{
    cursor: pointer;
  }
  .hadoop{
    position: absolute;
    width: 1200px;
    height: 150px;
    left:50%;
    transform: translateX(-50%);
    z-index: 99;
    margin-top:-75px ;
    background: url(../../../public/hadoopImg/hadoop.png) center;
    ul{
      margin-top: 60px;
      display: flex;
      justify-content: space-around;
      text-align: center;
      li{height: 40px;}
      .icon_a{
        background: url("../../../public/citybrianImg/icon_a.png")0px -2px no-repeat;
      }
      .icon_a:hover{
        background: url("../../../public/citybrianImg/icon_a1.png")0px -2px no-repeat;
      }
      .actived a{color: #01619E;}
      .icon_b{
        background: url("../../../public/citybrianImg/icon_b.png")0px -2px no-repeat;
      }
      .icon_b:hover{
        background: url("../../../public/citybrianImg/icon_b1.png")0px -2px no-repeat;
      }
      .icon_c{
        background: url("../../../public/citybrianImg/icon_c.png")0px -2px no-repeat;
      }
      .actived,.icon_c:hover{
        background: url("../../../public/citybrianImg/icon_c1.png")0px -2px no-repeat;
      }
      .icon_d{
        background: url("../../../public/citybrianImg/icon_d.png")0px -2px no-repeat;
      }
      .icon_d:hover{
        background: url("../../../public/citybrianImg/icon_d1.png")0px -2px no-repeat;
      }
      li:hover{
        color: #01619E;
      }
    }
    a{
      color: #333;
      padding-left: 50px;
    }
    a:hover,a:active{
      color: #01619E;
    }
  }
}

  .view-tip{
    width: 1200px;   
    margin: 0 auto;
    margin-bottom: 64px;
    text-align: left;
    .title{
      height: 33px;
      text-align: left;
      font-size: 24px;
      font-weight: bold;
      margin: 0 0 10px;
      padding-left: 10px;
      border-left: solid 3px #1E8DD4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre !important;
    }
    .detail{
      margin-top: 32px;
      text-align: left;
      font-size: 16px;
      line-height: 32px;
      color: #666;
      padding-left: 13px;
      p{
        margin-top:-3px
      }
      span{
        font-size: 18px;
        font-weight: bold;
        line-height: 20px;
        margin-bottom: 10px;
      }
      ul{
        list-style-type: none;
        margin-left: 5px;
        display: flex;
        justify-content: space-between;
        li{
          padding-bottom: 5px;
          width: 326px;
        }
      }
    }
  }
.cityImg{
  img{
    width: 1200px;
    margin: 0 auto;
  }  
}
.solution{
  height: 1284px;
}
</style>


// WEBPACK FOOTER //
// src/views/cityBrain/warningSolutions.vue